import React from 'react';
import { motion } from 'motion/react';

interface NumberNodeProps {
  value: number;
  index: number;
  total: number;
  showPolarity: boolean;
}

const NumberNode: React.FC<NumberNodeProps> = ({
  value,
  index,
  total,
  showPolarity,
}) => {
  const getColors = () => {
    if (!showPolarity)
      return 'border-zinc-800 bg-zinc-900/50 text-zinc-100 hover:border-emerald-500/50';
    if (value > 0)
      return 'border-emerald-500/30 bg-emerald-500/10 text-emerald-400 hover:border-emerald-500';
    if (value < 0)
      return 'border-rose-500/30 bg-rose-500/10 text-rose-400 hover:border-rose-500';
    return 'border-zinc-800 bg-zinc-900/50 text-zinc-500 hover:border-zinc-500';
  };

  const getDotColor = () => {
    if (!showPolarity) return 'bg-emerald-500';
    if (value > 0) return 'bg-emerald-500';
    if (value < 0) return 'bg-rose-500';
    return 'bg-zinc-500';
  };

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0, y: 20 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      transition={{
        delay: index * 0.05,
        type: 'spring',
        stiffness: 300,
        damping: 20,
      }}
      className="group relative"
    >
      <div
        className={`flex h-[60px] min-w-[60px] flex-col items-center justify-center rounded-lg border px-3 py-2 shadow-xl backdrop-blur-sm transition-all ${getColors()}`}
      >
        <span className="font-mono text-sm font-medium">{value}</span>
        <div
          className={`absolute -top-1 -right-1 h-2 w-2 rounded-full opacity-0 transition-opacity group-hover:opacity-100 ${getDotColor()}`}
        />
      </div>
    </motion.div>
  );
};

export default NumberNode;
